
import ArticleInfoBaseTemplate from '@root/views/article/components/info/ArticleInfoBaseTemplate';
import ArticleInfoCover from '@root/views/article/components/info/ArticleInfoCover.vue';

export default ArticleInfoBaseTemplate.extend({
  components: {
    ArticleInfoCover,
  },
  computed: {
    locale() {
      const { locale } = this.$channelConfig('settings');

      return locale.split('_')[0];
    },
    title() {
      return this.$props.article.content.title.html
        ? this.$props.article.content.title.html.replace(/(<\/?h1>)/gi, '')
        : this.$props.article.content.title.text;
    },
  },
});
